import home from './src/home.vue'
import Ecologicaldata from './src/Ecologicaldata.vue'

let views = {
    home,
    Ecologicaldata
};

export default views;